import styled from "styled-components";
import theme from "../../styles/theme";
import { GarageOutlined } from "@mui/icons-material";
import { StatsSection } from "./StatsTableStyles";

// Shown when a driver has no results at all for the selected simulator — the case the /stats
// endpoint used to answer with a 500. A checkered strip over a dashed, empty pit box: it should
// read as "the garage is empty", not as an error.

const CheckeredStrip = styled.div`
  height: 10px;
  background-image: linear-gradient(45deg, ${theme.colors.secondaryDark} 25%, transparent 25%),
    linear-gradient(-45deg, ${theme.colors.secondaryDark} 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${theme.colors.secondaryDark} 75%),
    linear-gradient(-45deg, transparent 75%, ${theme.colors.secondaryDark} 75%);
  background-size: 12px 12px;
  background-position:
    0 0,
    0 6px,
    6px -6px,
    -6px 0;
`;

const PitBox = styled.div`
  border: 2px dashed ${theme.colors.secondaryDark};
  border-top: none;
  border-radius: 0 0 4px 4px;
  background: #2a2a2a66;
  padding: 44px 24px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
`;

const PitIcon = styled.div`
  color: ${theme.colors.secondaryDark};
  display: flex;

  & .MuiSvgIcon-root {
    font-size: 64px;
  }
`;

const EmptyTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: ${theme.colors.white};
`;

const EmptyText = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 1.55;
  color: ${theme.colors.grey};
  max-width: 460px;
`;

const ResetButton = styled.button`
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${(props) => props.color || theme.colors.green};
  background: transparent;
  border: 2px solid ${(props) => props.color || theme.colors.green};
  border-radius: 4px;
  padding: 9px 18px;
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    color 0.18s ease;

  &:hover {
    background: ${(props) => props.color || theme.colors.green};
    color: ${theme.colors.dark};
  }
`;

// `onReset` is null when the dropdown already sits on "Усі симулятори" — there's nothing to reset
// to, and `simulatorLabel` then falls back to a phrase that covers every simulator.
const DriverStatsEmpty = ({ color, simulatorLabel, onReset }) => (
  <StatsSection>
    <CheckeredStrip />
    <PitBox>
      <PitIcon>
        <GarageOutlined />
      </PitIcon>
      <EmptyTitle>Заїздів не знайдено</EmptyTitle>
      <EmptyText>
        Пілот ще не брав участі в жодній сесії у {simulatorLabel} — ані кваліфікації, ані спринту,
        ані гонки.
      </EmptyText>
      {onReset && (
        <ResetButton color={color} onClick={onReset}>
          Усі симулятори
        </ResetButton>
      )}
    </PitBox>
  </StatsSection>
);

export default DriverStatsEmpty;
